export default "__VITE_ASSET__DH1eiRJ7__"